import { Controller } from "@hotwired/stimulus"

// Dim backdrop behind the mobile bottom sheet. Click anywhere → close.
// Visibility mirrors the sheet's data-state via syncState (reacts to
// bottom-sheet:state events).
export default class extends Controller {
  close() {
    this.dispatch("close", { bubbles: true })
  }

  syncState(event) {
    const state = event.detail?.state
    this.element.classList.toggle("hidden", !state || state === "closed")
  }
}
